import angular from 'angular';

export default angular.module('autoboard.backdropControls', [])
  .directive('bdControls', function () {
    'ngInject';

    return {
      restrict: 'E',
      transclude: true,
      scope: true,
      templateUrl: require('./bd-controls.template.html')
    }
  })
  .name;